module.exports = "/cyber/_next/static/images/3rd-place-prize-a40edf019872a23f6ba57793e931e626.png";